import { IpAddress, IpVersion } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { InfoSetTable } from "../InfoSets/InfoSetTable";
import { Device } from "../Core/Device";
import { HashSet } from "../Utils/HashSet";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface ApClientEntryJson {
//    mac_address: string;
//    ap_mac_address: string;
//    if_index: string;
//    slot_id: string;
//    port_id: string;
//    ip_address: string;
//    user_name: string;
//    status: string;
//    ess_index: string;
//    ssid: string;
//    device_id: string;
//    device_type: string;
//}

export class ApClientEntry /*implements ISerializable*/ implements ObjectSerializer {
    public MacAddress: MacAddress;

    public ApMacAddress: MacAddress;
    public get HasApMacAddress(): boolean {
        return this.ApMacAddress && !this.ApMacAddress.IsNull;
    }

    public IfIndex: number;
    public get HasIfIndex(): boolean {
        return this.IfIndex >= 0;
    }

    public SlotId: number;
    public get HasSlotId(): boolean {
        return this.SlotId >= 0;
    }

    public PortId: number;
    public get HasPortId(): boolean {
        return this.PortId >= 0;
    }

    public IpAddress: IpAddress;
    public get HasIpAddress(): boolean {
        return this.IpAddress && this.IpAddress.IsValidDiscoveryAddress;
    }

    public UserName: string;
    public get HasUserName(): boolean {
        return !!this.UserName;
    }

    public Status: string;
    public get HasStatus(): boolean {
        return !!this.Status;
    }

    public EssIndex: number;
    public get HasEssIndex(): boolean {
        return this.EssIndex >= 0;
    }

    public Ssid: string;
    public get HasSsid(): boolean {
        return !!this.Ssid;
    }

    public DeviceID: string;
    public get HasDeviceID(): boolean {
        return !!this.DeviceID;
    }

    public DeviceType: string;
    public get HasDeviceType(): boolean {
        return !!this.DeviceType;
	}

	public Iap: string;
	public get HasIap(): boolean {
		return !!this.Iap;
	}

	public IapDot11Mode: string;
	public get HasIapDot11Mode(): boolean {
		return !!this.IapDot11Mode;
	}

	public IapWifiMode: string;
	public get HasIapWifiMode(): boolean {
		return !!this.IapWifiMode;
	}


    constructor(macAddress?: MacAddress) {
        this.MacAddress = macAddress;

        this.Init();
    }

    private Init(): void {
        this.ApMacAddress = null;

        this.IfIndex = -1;
        this.SlotId = -1;
        this.PortId = -1;

        this.IpAddress = null;
        this.UserName = '';
        this.Status = '';

        this.EssIndex = -1;
        this.Ssid = '';

        this.DeviceID = '';
        this.DeviceType = '';
    }

    //public Deserialize(json: ApClientEntryJson) : void {
    //    if (json.mac_address !== undefined)
    //        this.MacAddress = MacAddress.CreateFromString(json.mac_address);
    //    if (json.ap_mac_address !== undefined)
    //        this.ApMacAddress = MacAddress.CreateFromString(json.ap_mac_address);
    //    if (json.if_index !== undefined)
    //        this.IfIndex = parseInt(json.if_index);
    //    if (json.slot_id !== undefined)
    //        this.SlotId = parseInt(json.slot_id);
    //    if (json.port_id !== undefined)
    //        this.PortId = parseInt(json.port_id);
    //    if (json.ip_address !== undefined)
    //        this.IpAddress = IpAddress.Create(json.ip_address);
    //    if (json.user_name !== undefined)
    //        this.UserName = json.user_name;
    //    if (json.status !== undefined)
    //        this.Status = json.status;
    //    if (json.ess_index !== undefined)
    //        this.EssIndex = parseInt(json.ess_index);
    //    if (json.ssid !== undefined)
    //        this.Ssid = json.ssid;
    //    if (json.device_id !== undefined)
    //        this.DeviceID = json.device_id;
    //    if (json.device_type !== undefined)
    //        this.DeviceType = json.device_type;
    //}

	public Write(obj: any, context: any): void {
		obj.ap_client_entry = {};
		obj = obj.ap_client_entry;

		obj.mac_address = ValueEncoder.EncodeMacAddress(this.MacAddress);

		if (this.HasApMacAddress)
			obj.ap_mac_address = ValueEncoder.EncodeMacAddress(this.ApMacAddress);

		if (this.HasIfIndex)
			obj.if_index = ValueEncoder.EncodeInteger(this.IfIndex);

		if (this.HasSlotId)
			obj.slot_id = ValueEncoder.EncodeInteger(this.SlotId);

		if (this.HasPortId)
			obj.port_id = ValueEncoder.EncodeInteger(this.PortId);

		if (this.HasIpAddress)
			obj.ip_address = ValueEncoder.EncodeIpAddress(this.IpAddress);

		if (this.HasUserName)
			obj.user_name = this.UserName;

		if (this.HasStatus)
			obj.status = this.Status;

		if (this.HasEssIndex)
			obj.ess_index = ValueEncoder.EncodeInteger(this.EssIndex);

		if (this.HasSsid)
			obj.ssid = this.Ssid;

		if (this.HasDeviceID)
			obj.device_id = this.DeviceID;

		if (this.HasDeviceType)
			obj.device_type = this.DeviceType;

		if (this.HasIap)
			obj.iap = this.Iap;

		if (this.HasIapDot11Mode)
			obj.iap_dot11_mode = this.IapDot11Mode;

		if (this.HasIapWifiMode)
			obj.wifi_mode = this.IapWifiMode;
	}

	public Read(obj: any, context: any): void {
		if (!obj.ap_client_entry)
			throw new Error();
		obj = obj.ap_client_entry;

		if (obj.mac_address !== undefined)
			this.MacAddress = ValueEncoder.DecodeMacAddress(obj.mac_address);

		if (obj.ap_mac_address !== undefined)
			this.ApMacAddress = ValueEncoder.DecodeMacAddress(obj.ap_mac_address);

		if (obj.if_index !== undefined)
			this.IfIndex = ValueEncoder.DecodeInteger(obj.if_index);

		if (obj.slot_id !== undefined)
			this.SlotId = ValueEncoder.DecodeInteger(obj.slot_id);

		if (obj.port_id !== undefined)
			this.PortId = ValueEncoder.DecodeInteger(obj.port_id);

		if (obj.ip_address !== undefined)
			this.IpAddress = ValueEncoder.DecodeIpAddress(obj.ip_address);

		if (obj.user_name !== undefined)
			this.UserName = obj.user_name;

		if (obj.status !== undefined)
			this.Status = obj.status;

		if (obj.ess_index !== undefined)
			this.EssIndex = ValueEncoder.DecodeInteger(obj.ess_index);

		if (obj.ssid !== undefined)
			this.Ssid = obj.ssid;

		if (obj.device_id !== undefined)
			this.DeviceID = obj.device_id;

		if (obj.device_type !== undefined)
			this.DeviceType = obj.device_type;

		if (obj.iap !== undefined)
			this.Iap = obj.iap;

		if (obj.iap_dot11_mode !== undefined)
			this.IapDot11Mode = obj.iap_dot11_mode;

		if (obj.wifi_mode !== undefined)
			this.IapWifiMode = obj.wifi_mode;
	}

}


export class ApClientTable extends InfoSetTable<MacAddress, ApClientEntry> {
    constructor(device: Device) {
        super(device);
    }

    public Add(macAddress: MacAddress): ApClientEntry {
        var clientEntry: ApClientEntry = this.GetValue(macAddress);

        if (!clientEntry) {
            clientEntry = new ApClientEntry(macAddress);
            this._table.Add(macAddress, clientEntry);
        }

        return clientEntry;
    }

    public AddEntry(clientEntry: ApClientEntry): boolean {

        if (this._table.ContainsKey(clientEntry.MacAddress))
            return false;

        this._table.Add(clientEntry.MacAddress, clientEntry);
        return true;
	}
        
    public get HasIpSightings(): boolean {
        return true;
    }

    public get IpSightings(): HashSet<IpAddress> {
        var ipAddresses = new HashSet<IpAddress>();

        this._table.ForEach((pair) => {
            if (pair.Value.HasIpAddress)
                ipAddresses.Add(pair.Value.IpAddress);
        });

        return (ipAddresses);
    }

    public get HasMacSightings(): boolean {
        return true;
    }

    public get MacSightings(): HashSet<MacAddress> {
        var macAddresses = new HashSet<MacAddress>();
        this._table.ForEach((pair) => {
            if (pair.Value.MacAddress)
                macAddresses.Add(pair.Value.MacAddress);
        });

        return (macAddresses);
    }
        
    //public DeserializeEntry(json: any): void {
    //    var entry = new ApClientEntry(null);
    //    entry.Deserialize(json);
    //    this.AddEntry(entry);
    //}

    //public EntryName(): string {
    //    return "ap_client_entry";
    //};

    //public static FromJson(json: any, device: Device) : ApClientTable {
    //    var result = new ApClientTable(device);
    //    result.Deserialize(json);
    //    return result;
    //}

	public Write(obj: any, context: any): void {
		obj.ap_client_info = {};
		obj = obj.ap_client_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._table.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ap_client_info)
			throw new Error();
		obj = obj.ap_client_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new ApClientEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}

}
